module.exports = __webpack_public_path__ + "static/media/gtc-logo.9b77761f.png";